import type * as Types from '../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type VerifyUnlockSessionQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type VerifyUnlockSessionQuery = {
  __typename?: 'Query';
  eventByName?: { __typename?: 'Event'; id: string; activeSession: { __typename?: 'EventSession'; id: string; person?: { __typename?: 'Person'; id: string } | null } } | null;
};

export const VerifyUnlockSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'VerifyUnlockSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeSession' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'person' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useVerifyUnlockSessionQuery__
 *
 * To run a query within a React component, call `useVerifyUnlockSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyUnlockSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyUnlockSessionQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useVerifyUnlockSessionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VerifyUnlockSessionQuery, VerifyUnlockSessionQueryVariables>) {
  return ApolloReactHooks.useQuery<VerifyUnlockSessionQuery, VerifyUnlockSessionQueryVariables>(VerifyUnlockSessionDocument, baseOptions);
}
export function useVerifyUnlockSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VerifyUnlockSessionQuery, VerifyUnlockSessionQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<VerifyUnlockSessionQuery, VerifyUnlockSessionQueryVariables>(VerifyUnlockSessionDocument, baseOptions);
}
export type VerifyUnlockSessionQueryHookResult = ReturnType<typeof useVerifyUnlockSessionQuery>;
export type VerifyUnlockSessionLazyQueryHookResult = ReturnType<typeof useVerifyUnlockSessionLazyQuery>;
export type VerifyUnlockSessionQueryResult = Apollo.QueryResult<VerifyUnlockSessionQuery, VerifyUnlockSessionQueryVariables>;
